import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { getHotComics } from '@/mocks/comics';

export default function HotComics() {
  const hot = getHotComics();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}>
              热门排行
            </h2>
            <p className="text-sm text-foreground-400 mt-2">全站最受欢迎的韩漫作品</p>
          </div>
          <Link
            to="/category/love?tab=hot"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {hot.map((comic, index) => (
            <div key={comic.id} className="relative">
              {index < 3 && (
                <div className="absolute -top-2 -left-2 z-10 w-7 h-7 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                  {index + 1}
                </div>
              )}
              <ComicCard comic={comic} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}